import { Injectable, Injector } from '@angular/core';

import { BehaviorContext } from './behavior-context';
import { globalMap, factoryMap } from './global-state';
import { Behavior } from './behavior';
import { BehaviorModel } from '../models/behavior-model';

export interface LocalContext {
  target?: any;
  targetModel?: any;
  parent?: any;
  parentModel?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root',
})
export class BehaviorService {
  constructor(private _injector: Injector) {}

  get globalContext() {
    const o = {};
    globalMap.forEach((value, key) => {
      o[key] = value;
    });
    return o;
  }

  getBehaviorByKey(behaviorKey) {
    return this._injector.get(behaviorKey);
  }

  async execute(
    behaviorModel: BehaviorModel | BehaviorModel[],
    localContext: LocalContext
  ) {
    if (!behaviorModel) {
      return;
    }
    if (Array.isArray(behaviorModel)) {
      let result = null;
      for (let i = 0; i < behaviorModel.length; i++) {
        result = await this.executeOne(behaviorModel[i], localContext);
      }
      return result;
    } else {
      return this.executeOne(behaviorModel, localContext);
    }
  }

  async executeOne(behaviorModel: BehaviorModel, localContext) {
    const context = new BehaviorContext(localContext);
    const bh: Behavior = this.getBehaviorByKey(behaviorModel.behaviorKey);
    return bh.execute(behaviorModel.args, context);
  }

  setGlobal(key, val) {
    globalMap.set(key, val);
  }

  getGlobal(key) {
    return globalMap.get(key);
  }

  hasGlobal(key) {
    return globalMap.has(key);
  }

  registerFactoryRef(id, ref) {
    factoryMap.set(id, ref);
  }

  unregisterFactoryRef(id) {
    factoryMap.delete(id);
  }

  getFactoryRef(id) {
    return factoryMap.get(id);
  }
}
